
import pluginModule_0 from '../../../plugin-cookie/lib/cookie.js'

import pluginModule_1 from '../../../../../src/client.ts'


export default function (options) {
  
    pluginModule_0(options)
  
    pluginModule_1(options)
  
}